module.exports = "<a [routerLink]=\"['./../../', this.jumpIssue, this.jumpArticle]\" [ngStyle]=\"styles\" routerLinkActive=\"active\"  >"